const DATE = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "2-digit",
});

const TIME = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

export function formatTimestamp(iso: string | null): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return `${DATE.format(date)}, ${TIME.format(date).toUpperCase()}`;
}

// null is an unknown balance, which is not the same as an exhausted one.
export function formatCredits(credits: number | null | undefined): string {
  if (credits === null || credits === undefined) return "Unavailable";
  return new Intl.NumberFormat("en-GB").format(credits);
}

export function formatLastUsed(known: boolean, iso: string | null): string {
  if (!known) return "—";
  if (iso === null) return "Not used";
  return formatTimestamp(iso);
}
